'use strict';

/* globals urls */

var $ = require('jquery');

$('.like-button').click(function(e) {
	e.preventDefault();
	var postID = parseInt($(this).data('post-id'), 10);
	var nonce = $(this).data('nonce');
	var likeCount = $(this).data('like-count');

	if ($(this).hasClass('liked')) {
		likeCount--;
	}
	else {
		likeCount++;
	}

	$(this).toggleClass('liked');

	$(this).find('.like-count').text(likeCount);

	$(this).data('like-count', likeCount);

	$.ajax({
		type: 'POST',
		url: urls.adminAjax,
		data: {
			'post_id': postID,
			'_wpnonce': nonce,
			'action': 'like_benefit',
		},
		dataType: 'json',
		xhrFields: {
			withCredentials: true,
		},
		complete: function(a, b){
			// console.log(a);
			// console.log(b);
		}
	})
	.then(function() {
	});
});
